<template>
  <div>
    <div
      class="modal animated fadeIn"
      id="weeklyexpensesModal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-md">
        <div class="modal-content">
          <div class="modal-body">
            <fieldset class="border p-3">
              <legend>
                <small style="font-size: 15px; font-weight: bold"
                  >Summary report</small
                >
              </legend>
              <form @submit.prevent="loadConsigneetrips()">
                <div class="row">
                  <input
                    type="hidden"
                    class="consignee_id"
                    :value="Consignee.id"
                  />
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>From date</label>
                      <input
                        type="date"
                        class="form-control full_From_date"
                        placeholder="daily expenses date"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>End date</label>
                      <input
                        type="date"
                        class="form-control full_End_date"
                        placeholder="daily expenses date"
                        required
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3">
                    <button
                      type="button"
                      class="btn btn-danger btn-flat"
                      data-dismiss="modal"
                    >
                      <i class="fa fa-times"></i> Cancel
                    </button>
                  </div>
                  <div class="col-md-3">
                    <button
                      type="submit"
                      class="btn btn-primary btn-flat creatingConsigneetrip"
                    >
                      <i class="fa fa-file-pdf-o"></i> Print
                    </button>
                    <button
                      type="button"
                      class="btn btn-primary btn-flat creatingConsigneetripLoader"
                    >
                      <span
                        class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <i
                        class="fa fa-spinner fa-spin"
                        style="font-size: 24px"
                      ></i>
                      please wait...
                    </button>
                  </div>
                </div>
              </form>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
    <fieldset class="border p-3">
      <legend class="auto-wp">
        <small style="font-size: 15px; font-weight: bold"
          >Manage consignees</small
        >
      </legend>

      <p></p>
      <div></div>
      <div>
        <div class="consigneesLoader">
          <span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
          <i
            class="fa fa-spinner fa-spin"
            style="font-size: 24px; color: blue"
          ></i
          >loading consignees...
        </div>
        <vue-good-table
          :columns="columns"
          :rows="systemConsignees"
          :fixed-header="true"
          :pagination-options="{
            enabled: true,
            mode: 'records',
            perPage: 6,
            position: 'bottom',
            perPageDropdown: [3, 7, 9],
            dropdownAllowAll: false,
            setCurrentPage: 1,
            nextLabel: 'next',
            prevLabel: 'prev',
            rowsPerPageLabel: 'rows per page',
            ofLabel: 'of',
            pageLabel: 'page', //for 'pages' mode
            allLabel: 'all',
          }"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'Action'">
              <button
                type="button"
                class="btn btn-primary btn-roundec"
                data-toggle="modal"
                data-target="#weeklyexpensesModal"
                @click="viewConsignes(props.row.id)"
              >
                <i class="fa fa-file-pdf-o"></i> Consignee trips
              </button>
            </span>
            <span v-else>{{ props.formattedRow[props.column.field] }}</span>
          </template>
        </vue-good-table>
      </div>
    </fieldset>
  </div>
</template>
  <script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      columns: [
        {
          label: "Consignee name",
          field: "consignee_name",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter consignee name",
          },
        },
        {
          label: "Phone number",
          field: "phone_number",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter phone number",
          },
        },
        {
          label: "Action",
          field: "Action",
          width: "122px",
          filterOptions: {
            enabled: true, // enable filter for this column
          },
        },
      ],
    };
  },
  created() {
    this.loadConsignees();
  },
  computed: {
    ...mapGetters(["systemConsignees", "Consignee"]),
  },
  methods: {
    ...mapActions(["loadConsignees", "viewConsignes", "loadConsigneetrips"]),
  },
};
</script>
  <style scoped>
.creatingConsigneetripLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/reports/consigneetrips.vue